/**
 * @file CertificatesWhereNote.tsx
 * @description Подпись под сертификатами производителя «Где видят
 * покупатели» (phase19.16, партия «Юридические документы», шаг В; SB141;
 * uiux-legal-steps-b-c §6.2): карточка товара и страница «Сертификаты и
 * декларации» — ссылкой на автоматическую группу в «Юридических
 * документах»; группы нет — «Создать страницу» (право настроек магазина,
 * создаёт и публикует группу). Список документов недоступен (нет права) —
 * подпись без ссылки.
 */

import { ChevronRight } from "lucide-react";
import { Link } from "react-router";

import { Button } from "../../ui/button";
import { useCurrentContext } from "../../../auth/hooks";
import { useLegalTargets } from "../../../hooks/site-view/useLegalTargets";
import { isCertificatesGroup } from "../../../lib/site-view/legal-targets";

const LEAD = "Где видят покупатели: карточка товара и страница";

export function CertificatesWhereNote() {
  const slug = useCurrentContext()?.shop?.slug ?? "";
  const legal = useLegalTargets();
  const group = legal.targets?.find(isCertificatesGroup) ?? null;

  if (group) {
    return (
      <p className="type-caption text-on-surface-variant">
        {LEAD}{" "}
        <Link to={`/shop/${slug}/settings/legal-documents/${group.id}`} className="inline-flex min-h-12 items-center gap-0.5 font-medium text-primary hover:underline">
          «{group.title}»
          <ChevronRight aria-hidden className="size-4" />
        </Link>
      </p>
    );
  }
  return (
    <div className="flex flex-col items-start gap-1">
      <p className="type-caption text-on-surface-variant">{LEAD} «Сертификаты и декларации».</p>
      {legal.targets !== null && legal.canCreate ? (
        <Button variant="outline" loading={legal.creating} onClick={() => void legal.createCertificates()}>
          Создать страницу
        </Button>
      ) : null}
    </div>
  );
}
